<template>
  <div id="app">
    <router-view
      :products="products"
      :categories="categories"
      :orders="viewOrders"
      :return-orders="viewReturnOrders"
      :temp-orders="tempOrders"
      :stock-imports="stockImports"
      :user="viewCurrentUser"
      @update-product="handleUpdateProduct"
      @add-product="handleAddProduct"
      @delete-product="handleDeleteProduct"
      @import-stock="handleImportStock"
      @save-draft="handleSaveDraft"
      @delete-draft="handleDeleteDraft"
      @restore-draft="handleRestoreDraft"
      @create-order="handleCreateOrder"
      @return-order="handleReturnOrder"
      @update-user="handleUpdateUser"
      @adjust-stock="handleAdjustStock"
      @delete-stock-import="handleDeleteStockImport"
      :debts="viewDebts"
      :transactions="transactions"
      :suppliers="suppliers"
      @add-category="handleAddCategory"
      @update-category="handleUpdateCategory"
      @delete-category="handleDeleteCategory"
      @add-debt="handleAddDebt"
      @update-debt="handleUpdateDebt"
      @pay-debt="handlePayDebt"
      @add-transaction="handleAddTransaction"
      @update-transaction="handleUpdateTransaction"
      @delete-transaction="handleDeleteTransaction"
      @add-supplier="handleAddSupplier"
      @update-supplier="handleUpdateSupplier"
      @delete-supplier="handleDeleteSupplier"
      :customers="customers"
      :users="users"
      @add-customer="handleAddCustomer"
      @update-customer="handleUpdateCustomer"
      @delete-customer="handleDeleteCustomer"
      @add-user="handleAddUser"
      @admin-update-user="handleAdminUpdateUser"
      @toggle-user-status="handleToggleUserStatus"
      @delete-user="handleDeleteUser"
      @login-success="handleLoginSuccess"
      @logout="handleLogout"
      :settings="settings"
      @update-settings="handleUpdateSettings"
      @update-user-role="handleUpdateUserRole"
      @reset-settings="handleResetSettings"
      :report-summary="reportRevenueSummary"
      :report-by-product="reportByProduct"
      :report-by-category="reportByCategory"
      :report-by-user="reportByUser"
      :report-daily-revenue="reportDailyRevenue"
      :report-filter="reportFilter"
      @update-report-filter="handleUpdateReportFilter"
      @print-bill="handlePrintBill"
      @reprint-bill="handleReprintBill"
      @print-debt-receipt="handlePrintDebtReceipt"
      @print-current-debt="handlePrintCurrentDebt"
      @print-transaction="handlePrintTransaction"
      :notifications="viewNotifications"
      :unread-noti-count="unreadNotiCount"
      @mark-read="handleMarkRead"
      @mark-all-read="handleMarkAllRead"
      @refresh-global="fetchInitialData"
      :printed-bills="printedBills"
    />

    <!-- Hidden Printable Area -->
    <div id="printable-area">
      <!-- Invoice Print -->
      <div v-if="printMode === 'invoice' && printableOrder">
        <div v-for="copy in (settings.invoice?.printCopies || 1)" :key="'inv-copy-'+copy" class="print-copy-page">
          <BillTemplate :order="printableOrder" :settings="settings.invoice" :system="settings.system" />
        </div>
      </div>
      
      <!-- Debt Receipt Print -->
      <div v-if="printMode === 'debtReceipt' && printableDebtReceipt">
        <div v-for="copy in (settings.debtReceipt?.printCopies || 1)" :key="'debt-copy-'+copy" class="print-copy-page">
          <DebtReceiptTemplate :data="printableDebtReceipt" :config="settings.debtReceipt" :system="settings.system" :settings="settings.invoice" />
        </div>
      </div>
      
      <!-- Transaction Receipt Print -->
      <div v-if="printMode === 'transactionReceipt' && printableTransaction">
        <div v-for="copy in (settings.transactionReceipt?.printCopies || 1)" :key="'trans-copy-'+copy" class="print-copy-page">
          <TransactionReceiptTemplate :data="printableTransaction" :config="settings.transactionReceipt" :system="settings.system" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BillTemplate from './components/reports/BillTemplate.vue';
import DebtReceiptTemplate from './components/reports/DebtReceiptTemplate.vue';
import TransactionReceiptTemplate from './components/reports/TransactionReceiptTemplate.vue';

export default {
  components: {
    BillTemplate,
    DebtReceiptTemplate,
    TransactionReceiptTemplate
  },
  data() {
    return {
      // --- USER PROFILE --- tài khoản người dùng
      // TODO: API INTEGRATION [GET] /api/auth/profile
      currentUser: {},
      currentUserId: null, // Track current logged in user ID
      // --- USERS ---
      // TODO: API INTEGRATION [GET] /api/users
      users: [],
      // --- CUSTOMERS ---
      // TODO: API INTEGRATION [GET] /api/customers
      customers: [],
      // --- CATEGORIES --- danh mục sản phẩm
      categories: [],
      // --- PRODUCTS --- danh sách sản phầm
      products: [],
      // --- ORDERS --- đơn hàng
      // TODO: API INTEGRATION [GET] /api/orders
      orders: [],
      // --- RETURN ORDERS --- đơn trả hàng
      // TODO: API INTEGRATION [GET] /api/return-orders
      returnOrders: [],
      // --- STOCK IMPORTS / ADJUSTMENTS --- lịch sử nhập kho, điều chỉnh kho
      stockImports: [],
      // --- TEMP ORDERS --- đơn tạm
      tempOrders: [],
      // --- PRINTED BILLS --- lịch sử in bill
      printedBills: [],
      printMode: 'invoice', // 'invoice' | 'debtReceipt' | 'transactionReceipt'
      printableOrder: null, // Order currently being printed
      printableDebtReceipt: null, // Debt receipt data
      printableTransaction: null, // Transaction receipt data
      // --- SUPPLIERS, DEBTS, TRANSACTIONS ---
      // nhà cung cấp
      // TODO: API INTEGRATION [GET] /api/suppliers
      suppliers: [],
      // --- NOTIFICATIONS ---
      notifications: [],
      // công nợ
      // TODO: API INTEGRATION [GET] /api/debts
      // công nợ
      // TODO: API INTEGRATION [GET] /api/debts
      debts: [],
      // giao dịch thu chi
      // TODO: API INTEGRATION [GET] /api/transactions
      // giao dịch thu chi
      transactions: [],
      // --- PRINTED BILLS ---
      printedBills: [], 
      // --- SETTINGS ---
      settings: {
          system: { storeName: '', logo: '', address: '', phone: '', email: '', language: 'vi', timezone: 'Asia/Ho_Chi_Minh', currency: 'VND', dateFormat: 'DD/MM/YYYY HH:mm' },
          sales: { allowNegativeStock: false, allowDebt: true, requireCustomer: false, defaultCustomerId: '', defaultUserId: '', allowEditPrice: true, discountType: 'percent' },
          inventory: { costMethod: 'average', lowStockAlert: true, lowStockThreshold: 10, allowManualStockAdjust: true, autoDeductStockOnOrder: true },
          finance: { enableDebtTracking: true, defaultReceivableAccount: '', defaultPayableAccount: '', allowPartialPayment: true },
          customer: { autoCreateCustomerFromOrder: true, requirePhoneOnOrder: true, customerTypes: [], defaultCustomerType: 'normal', debtLimitByType: {} },
          user: { roles: {} }, // Clean roles as requested
          invoice: { 
              showCompanyName: true, showCompanyLogo: true, showCompanyAddress: true, showCompanyPhone: true,
              showCustomerName: true, showCustomerPhone: true, showOrderCode: true, showOrderDate: true,
              showCashierName: true, showProductCode: false, showUnit: true, showQuantity: true, showPrice: true,
              showSubtotal: true, showTotalAmount: true, showPaidAmount: true, showDebtAmount: true, showPaymentMethod: true,
          },
          debtReceipt: {
              autoPrint: false,
              printCopies: 1,
              title: "PHIẾU BIÊN NHẬN THANH TOÁN",
              currentDebtTitle: "PHIẾU BÁO CÔNG NỢ"
          },
          transactionReceipt: {
              autoPrint: false,
              printCopies: 1,
              incomeTitle: "PHIẾU THU",
              expenseTitle: "PHIẾU CHI"
          }
      },
      defaultSettings: null, // Will be clone of initial settings
      reportFilter: {
          startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toLocaleDateString('en-CA'),
          endDate: new Date().toLocaleDateString('en-CA'),
          userId: null,
          categoryId: null
      },
      notiInterval: null,
      lastConfirmedUnreadCount: 0,
      lastConfirmedLatestId: 0
    };
  },
  created() {
      // Save default settings for reset functionality
      this.defaultSettings = JSON.parse(JSON.stringify(this.settings));
      
      this.handleLoadSettings();

      // Restore session from cookie
      const Cookie = require('vue-cookie');
      const Base64 = require('base-64');
      const token = Cookie.get('opt_ck2884');
      if (token) {
          try {
              const decoded = Base64.decode(token);
              const parts = decoded.includes('-') ? decoded.split('-') : [null, decoded];
              this.currentUserId = parts[0];
              const rawToken = parts[1] || parts[0]; // fallback for old format
              
              // Restore Token to Axios Header (MUST be the raw token, not the encoded cookie)
              this.$root.api.defaults.headers.common['User-Token'] = rawToken;
              
              // Wait for Auth Info before fetching data dependent on User/Role
              // Skip heavy data fetch on login page to avoid "Access Denied" alerts on new devices
              const isLoginPage = window.location.href.includes('login') || window.location.hash.includes('login');
              if (!isLoginPage) {
                  this.fetchUserAuth().then(() => {
                      this.fetchInitialData?.();
                      this.startNotificationPolling?.();
                  });
              }
          } catch (e) {
              this.currentUserId = null;
          }
      } 

      // Removing duplicate calls that are covered by fetchInitialData
      // this.fetchLoGachPrintedBills();
      // this.fetchLoGachNotifications(); 

      
      this.calculateDebts();
      // Simulate fetching user profile
      const savedUser = localStorage.getItem('userProfile');
      if (savedUser) {
          this.currentUser = JSON.parse(savedUser);
      }
  },
  beforeDestroy() {
      this.stopNotificationPolling?.();
  },
  computed: {
    viewCurrentUser() {
      return this.$root.auth || this.users.find(u => u.id == this.currentUserId) || this.currentUser || {};
    },
    viewOrders() {
      return this.orders.map(order => {
        // Find customer
        const customer = this.customers.find(c => c.id === order.customerId) || order.customer || { name: 'Khách lẻ' };
        // Find user
        const user = this.users.find(u => u.id === order.userId) || order.user || { name: 'Admin' };
        // Hydrate cart items (ensure product exists and has snapshots)
        const hydratedCart = (order.cart || []).map(item => {
           const productId = item.productId || (item.product && item.product.id);
           const product = this.products.find(p => p.id == productId);
           // Ensure snapshots exist
           const price = item.price !== undefined ? item.price : (item.product?.price || product?.price || 0);
           const cost = item.cost !== undefined ? item.cost : (item.product?.costPrice || product?.costPrice || 0);

           return {
             ...item,
             price,
             cost,
             product: product || { name: item.name || (item.product && item.product.name) || 'Sản phẩm đã xóa', id: productId }
           };
        });
        return {
          ...order,
          customer: {
              ...customer,
              note: order.note || customer.note || '' // Use order-specific note if valid
          },
          user,
          cart: hydratedCart
        };
      });
    },
    viewDebts() {
       return this.debts.map(debt => {
          let partnerName = 'Unknown';
          if (debt.partnerType === 'customer') {
             const c = this.customers.find(x => x.id === debt.partnerId);
             if (c) partnerName = c.name;
          } else if (debt.partnerType === 'supplier') {
             const s = this.suppliers.find(x => x.id === debt.partnerId);
             if (s) partnerName = s.name;
          }
          return {
             ...debt,
             partnerName
          };
       });
    },
    viewReturnOrders() {
      return this.returnOrders.map(ro => {
        const hydratedItems = (ro.items || ro.cart || []).map(item => {
           const productId = item.productId || (item.product && item.product.id);
           const product = this.products.find(p => p.id == productId);
           const price = item.price !== undefined ? item.price : (item.product?.price || product?.price || 0);
           
           // FIX: If saved cost is 0 or missing, use current product cost
           let cost = item.cost !== undefined ? item.cost : (item.product?.costPrice || product?.costPrice || 0);
           if (parseFloat(cost) === 0 && product?.costPrice) {
               cost = product.costPrice;
           }

           return {
             ...item,
             price,
             cost,
             product: product || { name: item.name || (item.product && item.product.name) || 'Sản phẩm đã xóa', id: productId }
           };
        });
        return {
          ...ro,
          items: hydratedItems,
          cart: hydratedItems
        };
      });
    },
    reportFilteredOrders() {
      const { startDate, endDate, userId } = this.reportFilter;
      // Use YYYY-MM-DD strings for consistent comparison
      const startStr = startDate || '0000-01-01';
      const endStr = endDate || '9999-12-31';

      return this.viewOrders.filter(order => {
        // Extract date part from createdAt (handled both '2025-09-23 14:15' and ISO)
        const dStr = new Date(order.createdAt).toLocaleDateString('en-CA');
        const matchDate = dStr >= startStr && dStr <= endStr;
        const matchUser = !userId || order.userId === userId;
        return matchDate && matchUser;
      });
    },
    reportFilteredReturns() {
      const { startDate, endDate } = this.reportFilter;
      const startStr = startDate || '0000-01-01';
      const endStr = endDate || '9999-12-31';

      return this.viewReturnOrders.filter(ro => {
        const dStr = new Date(ro.createdAt).toLocaleDateString('en-CA');
        const matchDate = dStr >= startStr && dStr <= endStr;
        return matchDate;
      });
    },
    reportRevenueSummary() {
      const orders = this.reportFilteredOrders;
      const returns = this.reportFilteredReturns;

      const totalRevenue = orders.reduce((sum, o) => sum + parseFloat(o.totalBill || 0), 0);
      const totalCost = orders.reduce((sum, o) => sum + parseFloat(o.totalCost || 0), 0);
      const totalReturned = returns.reduce((sum, r) => sum + parseFloat(r.totalRefund || 0), 0);
      
      const totalReturnCost = returns.reduce((sum, r) => {
          return sum + (r.items || []).reduce((s, i) => {
              const qty = parseFloat(i.returnQty || i.quantity || 0);
              const cost = parseFloat(i.cost || 0);
              return s + (cost * qty);
          }, 0);
      }, 0);

      const netRevenue = totalRevenue - totalReturned;
      const netCost = totalCost - totalReturnCost;
      const grossProfit = netRevenue - netCost;

      return {
        totalRevenue,
        totalCost,
        totalReturned,
        netRevenue,
        grossProfit,
        totalOrders: orders.length,
        totalReturnOrders: returns.length
      };
    },
    reportByProduct() {
      const orders = this.reportFilteredOrders;
      const returns = this.reportFilteredReturns;
      const { categoryId } = this.reportFilter;

      const productMap = {};

      orders.forEach(order => {
        order.cart.forEach(item => {
          const pId = item.productId || item.product?.id;
          if (categoryId && item.product?.category !== categoryId) return;

          if (!productMap[pId]) {
            productMap[pId] = {
              productId: pId,
              productName: item.product?.name || item.name || 'Unknown',
              quantitySold: 0,
              revenue: 0,
              cost: 0,
              profit: 0
            };
          }
          productMap[pId].quantitySold += parseFloat(item.quantity || 0);
          productMap[pId].revenue += (parseFloat(item.price || 0) * parseFloat(item.quantity || 0));
          productMap[pId].cost += (parseFloat(item.cost || 0) * parseFloat(item.quantity || 0));
        });
      });

      returns.forEach(ro => {
        (ro.items || []).forEach(item => {
          const pId = item.productId || item.product?.id;
          if (categoryId && item.product?.category !== categoryId) return;

          if (productMap[pId]) {
            productMap[pId].quantitySold -= parseFloat(item.returnQty || 0);
            productMap[pId].revenue -= (parseFloat(item.price || 0) * parseFloat(item.returnQty || 0));
            productMap[pId].cost -= (parseFloat(item.cost || 0) * parseFloat(item.returnQty || 0));
          }
        });
      });

      return Object.values(productMap).map(p => ({
        ...p,
        profit: p.revenue - p.cost
      })).sort((a, b) => b.revenue - a.revenue);
    },
    reportByCategory() {
      const productStats = this.reportByProduct;
      const categoryMap = {};

      productStats.forEach(p => {
        const product = this.products.find(x => x.id === p.productId);
        const catId = product?.category || 'other';
        const category = this.categories.find(c => c.id === catId);
        const catName = category ? category.name : (catId === 'other' ? 'Khác' : 'N/A');

        if (!categoryMap[catId]) {
          categoryMap[catId] = {
            categoryId: catId,
            categoryName: catName,
            revenue: 0,
            cost: 0,
            profit: 0
          };
        }
        categoryMap[catId].revenue += p.revenue;
        categoryMap[catId].cost += p.cost;
        categoryMap[catId].profit += p.profit;
      });

      return Object.values(categoryMap).sort((a, b) => b.revenue - a.revenue);
    },
    reportByUser() {
      const orders = this.reportFilteredOrders;
      const userMap = {};

      orders.forEach(order => {
        const uId = order.userId || 'admin';
        const user = this.users.find(u => u.id === uId) || { name: 'Admin' };

        if (!userMap[uId]) {
          userMap[uId] = {
            userId: uId,
            userName: user.name,
            totalOrders: 0,
            revenue: 0,
            profit: 0
          };
        }
        userMap[uId].totalOrders++;
        userMap[uId].revenue += parseFloat(order.totalBill || 0);
        userMap[uId].profit += (parseFloat(order.totalBill || 0) - parseFloat(order.totalCost || 0));
      });

      return Object.values(userMap).sort((a, b) => b.revenue - a.revenue);
    },
    reportDailyRevenue() {
      const orders = this.reportFilteredOrders;
      const returns = this.reportFilteredReturns;
      const dailyMap = {};

      orders.forEach(order => {
        const date = new Date(order.createdAt).toISOString().split('T')[0];
        if (!dailyMap[date]) {
          dailyMap[date] = { date, revenue: 0, profit: 0, ordersCount: 0 };
        }
        dailyMap[date].revenue += parseFloat(order.totalBill || 0);
        dailyMap[date].profit += (parseFloat(order.totalBill || 0) - parseFloat(order.totalCost || 0));
        dailyMap[date].ordersCount++;
      });
      returns.forEach(ro => {
        const date = new Date(ro.createdAt).toISOString().split('T')[0];
        if (!dailyMap[date]) {
          dailyMap[date] = { date, revenue: 0, profit: 0, ordersCount: 0 };
        }
        dailyMap[date].revenue -= parseFloat(ro.totalRefund || 0);
        const returnCost = (ro.items || []).reduce((sum, i) => sum + (parseFloat(i.cost) * parseFloat(i.returnQty)), 0);
        dailyMap[date].profit -= (parseFloat(ro.totalRefund || 0) - returnCost);
      });

      return Object.values(dailyMap).sort((a, b) => a.date.localeCompare(b.date));
    },
    viewNotifications() {
      const userRole = this.viewCurrentUser?.role || 'staff';
      console.log('viewNotifications filter:', { userRole, count: this.notifications.length });
      return this.notifications
        .filter(n => {
           const isVisible = (n.roleVisibility || []).includes(userRole);
           return isVisible;
        })
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    unreadNotiCount() {
      return this.viewNotifications.filter(n => !n.read).length;
    },
  },
  methods: {
    // --- TEMP ORDERS ---
    // --- TEMP ORDERS ---
    fetchLoGachTempOrders() {
       this.$root.api.get('logach/getLoGachTempOrders').then(res => {
          if (res.data.status === 'OK') {
              // Map backend structure to frontend model
              this.tempOrders = res.data.list.map(t => ({
                  id: t.id,
                  customer: t.customer_info,
                  cart: t.cart_data,
                  // Flatten meta_data fields
                  totalBill: t.meta_data?.totalBill || 0,
                  totalAmount: t.meta_data?.totalAmount || 0,
                  discount: t.meta_data?.discount || 0,
                  paid: t.meta_data?.paid || 0,
                  paymentMethod: t.meta_data?.paymentMethod || 'cash',
                  debt: t.meta_data?.debt || 0,
                  userId: t.user_id,
                  userName: t.user_name || 'Không rõ',
                  note: t.meta_data?.note,
                  createdAt: t.created_at
              }));
          }
       }).catch(console.error);
    },

    // --- OFFICIAL ORDERS ---
    fetchLoGachOrders() {
        // Can add params for filtering if needed
        this.$root.api.get('logach/getLoGachOrders').then(res => {
            if (res.data.status === 'OK') {
                this.orders = res.data.list;
            }
        }).catch(console.error);
    },
    fetchLoGachReturnOrders() {
        this.$root.api.get('logach/getLoGachReturnOrders').then(res => {
            if (res.data.status === 'OK') {
                this.returnOrders = res.data.list || [];
            }
        }).catch(console.error);
    },
    // saveTempOrders() removed - using API directly in handleAddDraft
    async fetchInitialData() {
        this.fetchLoGachCategories();
        this.fetchLoGachProducts();
        this.fetchLoGachSuppliers();
        this.fetchLoGachTempOrders();
        this.fetchLoGachOrders();
        this.fetchLoGachReturnOrders();
        this.fetchLoGachStockHistory();
        this.fetchLoGachUsers();
        this.fetchLoGachCustomers();
        this.fetchLoGachDebts();
        this.fetchLoGachTransactions();
        this.fetchLoGachNotifications();
        this.fetchLoGachPrintedBills();
    },
    fetchLoGachNotifications() {
        if (!this.currentUserId) {
            this.notifications = [];
            this.$root.unreadNotiCount = 0;
            return;
        }

        setTimeout(() => {
            if (!this.currentUserId) return;
            const userId = this.currentUserId;
            const role = this.viewCurrentUser?.role || 'admin';
            console.log('Fetching notifications for:', { userId, role });
            
            this.$root.api.get('logach/getLoGachNotifications', { params: { limit: 50, role, userId } }).then(res => {
                if (res.data.status === 'OK') {
                    console.log('Notifications fetched:', res.data.list.length);
                    const list = res.data.list.map(n => ({
                        id: n.id,
                        title: n.title,
                        message: n.message,
                        level: n.level || 'info',
                        type: n.type || 'system',
                        code: n.code || 'GENERAL',
                        roleVisibility: n.role_visibility || [],
                        read: n.read,
                        createdAt: n.created_at
                    }));
                    this.notifications = list;
                    
                    // Explicitly calculate count
                    const userRole = this.viewCurrentUser?.role || 'staff';
                    const filtered = list.filter(n => {
                        const visible = (n.roleVisibility || []).includes(userRole);
                        return visible;
                    });
                    const count = filtered.filter(n => !n.read).length;
                    
                    this.$root.unreadNotiCount = count;

                    // Sync check states to avoid immediate re-fetch
                    this.lastConfirmedUnreadCount = count;
                    if (list.length > 0) {
                        this.lastConfirmedLatestId = list[0].id;
                    }
                }
            }).catch(err => {
                console.error('Fetch notifications error:', err);
            });
        }, 300);
    },
    fetchLoGachCustomers() {
        this.$root.api.get('logach/getLoGachCustomers', { params: { per: 1000 } }).then(res => {
             if (res.data.status === 'OK' || res.data.code === 200) {
                 const list = res.data.list || (res.data.data && res.data.data.list) || [];
                 this.customers = list;
                 this.calculateDebts();
             }
        }).catch( console.error );
    },
    fetchLoGachDebts() {
        this.$root.api.get('logach/getLoGachDebts').then(res => {
            if (res.data.status === 'OK') {
                this.debts = res.data.list.map(d => ({
                    id: d.id,
                    partnerId: d.partner_id,
                    partnerName: d.partner_name,
                    partnerPhone: d.partner_phone,
                    partnerType: d.partner_type,
                    type: d.type,
                    amount: parseFloat(d.amount),
                    cash_amount: parseFloat(d.cash_amount || 0),
                    transfer_amount: parseFloat(d.transfer_amount || 0),
                    note: d.note,
                    orderId: d.order_id,
                    createdAt: d.created_at
                }));
                this.calculateDebts();
            }
        }).catch(console.error);
    },
    // --- TRANSACTIONS ---
    fetchLoGachTransactions() {
        this.$root.api.get('logach/getLoGachTransactions').then(res => {
            if (res.data.status === 'OK') {
                this.transactions = res.data.list.map(t => {
                    // Try to parse 'Người thực hiện: XXX' from note
                    let creator = t.user_name || t.user_username;
                    if (!creator && t.note) {
                        // Improved regex to capture name between "Người thực hiện:" and optional following parts
                        const match = t.note.match(/Người thực hiện:\s*([^-\r\n\t]+)/);
                        if (match) {
                            creator = match[1].trim();
                        }
                    }
                    
                    return {
                        id: t.id,
                        type: t.type,
                        amount: parseFloat(t.amount || 0),
                        cash_amount: parseFloat(t.cash_amount || 0),
                        transfer_amount: parseFloat(t.transfer_amount || 0),
                        folder: t.folder,
                        note: t.note,
                        createdBy: creator || '',
                        createdAt: t.created_at
                    };
                });
            } else {
                 this.$root.alert(res.data.error || res.data.message || 'Lỗi lấy dữ liệu Transaction', 'Lỗi API', 'error');
            }
        }).catch(err => {
             console.error(err);
             this.$root.alert('Lỗi kết nối Transaction: ' + err.message, 'Lỗi Mạng', 'error');
        });
    },
    handleAddTransaction(transaction) {
        const userObj = this.viewCurrentUser;
        const uName = userObj?.full_name || userObj?.fullname || userObj?.first_name || userObj?.name || userObj?.username;


         // API Integration
         const payload = {
             id: transaction.id, // Include ID if it's an update
             type: transaction.type,
             amount: transaction.amount,
             cashAmount: transaction.cash_amount || transaction.cashAmount || 0,
             transferAmount: transaction.transfer_amount || transaction.transferAmount || 0,
             folder: transaction.folder,
             note: transaction.note,
             createdAt: transaction.createdAt
         };
         
         // Append creator to note if it's a new manual transaction to preserve history
         if (!payload.id && this.currentUser && uName) {
             const creatorLabel = ` - Người thực hiện: ${uName}`;
             if (!payload.note) {
                 payload.note = `Thực hiện bởi: ${uName}`;
             } else if (!payload.note.includes('Người thực hiện:')) {
                 payload.note += creatorLabel;
             }
         }
         this.$root.api.post('logach/postSaveLoGachTransaction', payload).then(res => {
             if (res.data.status === 'OK') {
                 this.$toast?.(transaction.id ? 'Đã cập nhật giao dịch' : 'Đã lưu giao dịch');
                 this.fetchInitialData();

                 // Auto-print logic for newly created transactions
                 if (!transaction.id) {
                     const userObj = this.viewCurrentUser;
                       const creatorName = userObj?.full_name || userObj?.fullname || userObj?.first_name || userObj?.name || userObj?.username || '';

                     const receiptData = {
                         type: transaction.type,
                         amount: transaction.amount,
                         cash_amount: transaction.cash_amount || transaction.cashAmount || 0,
                         transfer_amount: transaction.transfer_amount || transaction.transferAmount || 0,
                         note: transaction.note,
                         createdAt: transaction.createdAt || new Date().toISOString(),
                         createdBy: creatorName
                     };

                     const showReceipt = () => {
                         this.handlePrintTransaction(receiptData);
                     };

                     const autoPrint = this.settings?.transactionReceipt?.autoPrint;
                     if (autoPrint) {
                         showReceipt();
                     } else {
                         this.$dialog.confirm({
                              title: 'Lưu thành công',
                              message: 'Bạn có muốn in phiếu này không?',
                              confirmButtonText: 'In phiếu',
                              cancelButtonText: 'Đóng'
                         }).then(() => {
                              showReceipt();
                         }).catch(() => {});
                     }
                 }
             } else {
                 this.$root.alert(res.data.message || 'Lỗi lưu giao dịch');
             }
         }).catch(this.$root.showError);
    },
    handleDeleteTransaction(transactionId) {
         this.$root.api.post('logach/postDeleteLoGachTransaction', { id: transactionId }).then(res => {
             if (res.data.status === 'OK') {
                 this.$toast?.('Đã xóa giao dịch');
                 this.fetchInitialData();
             } else {
                 this.$root.alert(res.data.message || 'Lỗi xóa giao dịch');
             }
         }).catch(this.$root.showError);
    },
    handleDeleteStockImport(importId) {
        if (!importId) return;
        this.$root.api.post('logach/postDeleteLoGachStockImport', { 
            id: importId,
            user_id: this.currentUserId
        }).then(res => {
            if (res.data && res.data.status === 'OK') {
                this.$toast?.success(res.data.message || 'Xóa phiếu nhập thành công');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data?.message || 'Lỗi khi xóa phiếu');
            }
        }).catch(err => {
            this.$root.alert('Lỗi kết nối: ' + err.message);
        });
    },
    fetchLoGachUsers() {
        this.$root.api.get('logach/user/list').then(res => {
            if (res.data.status === 'OK') {
                this.users = res.data.list;
            }
        });
    },
    fetchLoGachSuppliers() {
        this.$root.api.get('logach/getLoGachSuppliers').then(res => {
            if (res.data.status === 'OK') {
                this.suppliers = res.data.list;
            }
        });
    },
    fetchLoGachStockHistory() {
        this.$root.api.get('logach/getLoGachStockHistory').then(res => {
            if (res.data.status === 'OK') {
                this.stockImports = res.data.list.map(i => ({
                    id: i.import_code,
                    type: i.type, // Use backend type (import/adjust)
                    product: {
                        id: i.product_id,
                        name: i.product_name,
                        code: i.product_code,
                        costPrice: i.cost_price_snap
                    },
                    quantity: i.quantity,
                    note: i.note,
                    totalAmount: i.total_amount, // Map total amount
                    createdAt: i.created_at,
                    user: { name: i.user_name || 'Admin' },
                    supplierName: i.supplier_name // Map supplier name
                }));
            }
        });
    },
    fetchLoGachCategories() {
        this.$root.api.get('logach/getLoGachCategories').then(res => {
            if (res.data.status === 'OK') {
                this.categories = res.data.list;
                console.log('cats',this.categories);
            }
        }).catch(err => {
            console.error('Lỗi lấy danh mục:', err);
        });
    },
    fetchLoGachProducts() {
        // Lấy tất cả sản phẩm (có thể hỗ trợ phân trang sau)
        this.$root.api.get('logach/getLoGachProducts', { params: { per: 1000 } }).then(res => {
            if (res.data.status === 'OK') {
                // Map dữ liệu từ Backend sang Frontend format
                this.products = res.data.list.map(p => ({
                    id: p.id,
                    name: p.name,
                    code: p.code,
                    price: p.sale_price,
                    costPrice: p.cost_price,
                    stock: p.stock_quantity,
                    unit: p.unit,
                    category: p.category_id,
                    image: p.image || '',
                    status: p.status
                }));
            }
        }).catch(err => {
            console.error('Lỗi lấy sản phẩm:', err);
        });
    },
    saveNotifications() {
        // Deprecated: Logic moved to Backend
    },
    handleMarkRead(id) {
        // Optimistic update
        const index = this.notifications.findIndex(n => n.id === id);
        if (index !== -1) {
            this.notifications[index].read = true;
            // Sync to root
            this.$root.unreadNotiCount = this.unreadNotiCount;
        }

        // API Call
        const userId = this.currentUserId;
        this.$root.api.post('logach/postMarkReadLoGachNotification', { id, userId }).then(res => {
             if (res.data.status !== 'OK') {
                 console.error('Lỗi đánh dấu đã đọc:', res.data.message);
             }
        }).catch(err => console.error(err));
    },
    handleMarkAllRead() {
        const userRole = this.viewCurrentUser?.role || 'staff';
        
        // Optimistic Update
        this.notifications.forEach(n => {
            n.read = true;
        });
        // Sync to root
        this.$root.unreadNotiCount = 0;

        // API Call
        const userId = this.currentUserId;
        this.$root.api.post('logach/postMarkAllReadLoGachNotification', { userId, role: userRole }).then(res => {
             if (res.data.status !== 'OK') {
                 console.error('Lỗi đánh dấu tất cả:', res.data.message);
                 // Revert or alert if needed, but usually benign
             }
        }).catch(err => console.error(err));

        this.$toast?.('Đã đánh dấu tất cả là đã đọc');
    },
    handlePushNotification(payload) {
        const newNoti = {
            id: 'noti-' + Date.now(),
            read: false,
            createdAt: new Date().toISOString(),
            ...payload
        };
        this.notifications.unshift(newNoti);
        // We don't save the whole noti to localstorage in this mock, 
        // normally this comes from backend.
    },
    // --- PRINTED BILLS ---
    fetchLoGachPrintedBills() {
      // Use limit mode (legacy) - only for handlePrintBill/handleReprintBill lookups in App.vue
      // PrintedBills.vue page handles its own server-side pagination separately
      this.$root.api.get('logach/getLoGachPrintedBills', { params: { limit: 200 } }).then(res => {
          if (res.data.status === 'OK') {
              this.printedBills = res.data.list || res.data.message?.list || [];
          }
      });
    },
    handlePrintBill({ order, orderId, printType, isNewOrder, isDraft }) {
        let orderToPrint = order;
        if (!orderToPrint && orderId) {
            orderToPrint = this.viewOrders.find(o => o.id === orderId);
        }
        
        // Ensure user info is populated
        if (orderToPrint && !orderToPrint.user && orderToPrint.userId) {
            const u = this.users.find(x => x.id === orderToPrint.userId) || this.currentUser;
            if (u) {
                orderToPrint = { ...orderToPrint }; // Clone first level to avoid mutation if it was from store
                orderToPrint.user = { 
                    ...u, 
                    name: u.name || u.fullname || u.username || 'Thu ngân' 
                };
            }
        }
        
        if (!orderToPrint) {
             this.$toast?.fail('Không tìm thấy thông tin đơn hàng để in');
             return;
        }

        // If this is not a new order (i.e. it's a reprint from OrderHistory), 
        // try to find the previous snapshot to preserve historical debt!
        if (!isNewOrder && !isDraft) {
            // Find the oldest snapshot for this order to get the original debt state
            // Or the latest? Usually the first print has the correct old debt at creation time.
            const existingPrints = (this.printedBills || []).filter(b => b.orderId === orderToPrint.id);
            if (existingPrints.length > 0) {
                 // Sort by printedAt ascending to get the very first print
                 existingPrints.sort((a, b) => new Date(a.printedAt) - new Date(b.printedAt));
                 const historicalSnapshot = existingPrints[0].snapshot;
                 // Use the historical order snapshot completely!
                 this.printMode = 'invoice';
                 this.printableOrder = JSON.parse(JSON.stringify(historicalSnapshot.order));
                 this.$nextTick(() => {
                     window.print();
                 });
                 return; // Dừng lại ở đây, không tạo snapshot mới hay dùng dữ liệu hiện tại
            }
        }

        // DEBT CALCULATION LOGIC
        // Clone deeply to ensure we don't affect original object
        orderToPrint = JSON.parse(JSON.stringify(orderToPrint));

        // Logic: If it's a NEW order just printed from sales screen, the local customer.debtAmount 
        // likely is the "Previous Balance" (before this order).
        // So Total Debt = Previous Balance + This Order Debt.
        // If it's a historical printed bill, we rely on the snapshot or current debt (heuristically).
        
        let actualDebtDelta = (orderToPrint.totalBill || 0) - (orderToPrint.paid || 0);
        if (actualDebtDelta < 0 && !orderToPrint.convertToDeposit) {
             actualDebtDelta = 0; // Did not convert to deposit, so debt doesn't decrease from overpayment
        }
        
        // Default to what's in the object:
        // 1. Snapshot's historical finalTotalDebt (from prior prints)
        // 2. Customer's current debt as fallback
        let displayTotalDebt = orderToPrint.finalTotalDebt !== undefined 
            ? Number(orderToPrint.finalTotalDebt) 
            : Number(orderToPrint.customer?.debtAmount || 0);

        if (isNewOrder) {
            // New Order context: debtAmount is presumed to be Previous Balance.
            // So we add the current debt delta to get the Post-Transaction Balance.
            // JS handles negative numbers perfectly.
            displayTotalDebt += Number(actualDebtDelta);
        }
        
        // Store explicit final total debt for template to use natively
        orderToPrint.finalTotalDebt = displayTotalDebt;
        orderToPrint.isDraft = !!isDraft;


        // 1. Prepare Snapshot
        const snapshot = {
            order: orderToPrint,
            settings: this.settings.invoice
        };

        // 2. Save to Server History
        const payload = {
            orderId: orderToPrint.id,
            billNo: ((this.printedBills?.length || 0) + 1).toString().padStart(6, '0'),
            snapshot: snapshot
        };

        this.$root.api.post('logach/postSaveLoGachPrintedBill', payload).then(res => {
             if (res.data.status === 'OK') {
                  this.fetchLoGachPrintedBills(); // Refresh list
             }
        });

        // 3. Client Side Print Trigger
        this.printMode = 'invoice';
        this.printableOrder = orderToPrint;
        
        this.$nextTick(() => {
            window.print();
        });
    },
    handlePrintDebtReceipt(receiptData) {
        this.printMode = 'debtReceipt';
        this.printableDebtReceipt = receiptData;
        
        this.$nextTick(() => {
            window.print();
        });
    },
    handlePrintCurrentDebt(receiptData) {
        this.printMode = 'debtReceipt';
        this.printableDebtReceipt = receiptData;
        
        this.$nextTick(() => {
            window.print();
        });
    },
    handlePrintTransaction(receiptData) {
        this.printMode = 'transactionReceipt';
        this.printableTransaction = receiptData;
        
        this.$nextTick(() => {
            window.print();
        });
    },
    handleReprintBill(printedBillId) {
        const bill = this.printedBills.find(b => b.id === printedBillId);
        if (bill) {
            this.printMode = 'invoice';
            this.printableOrder = JSON.parse(JSON.stringify(bill.snapshot.order));
            this.$nextTick(() => {
                window.print();
            });
        }
    },
    handleSaveDraft(order) {
       // Construct payload for API
       const payload = {
           id: order.id && !String(order.id).startsWith('DH-') ? order.id : null, // If new (starts with DH-), send null
           customer_info: order.customer,
           cart_data: order.cart,
           meta_data: {
               discount: order.discount,
               paid: order.paid,
               paymentMethod: order.paymentMethod,
               totalAmount: order.totalAmount,
               totalBill: order.totalBill,
               debt: order.debt,
               userId: order.userId,
               note: order.note
           }
       };

       this.$root.api.post('logach/postSaveLoGachTempOrder', payload).then(res => {
           if (res.data.status === 'OK') {
               this.$toast?.success('Đã lưu đơn tạm lên hệ thống');
               this.fetchInitialData();
           } else {
               this.$toast?.fail(res.data.message || 'Lỗi lưu đơn tạm');
           }
       }).catch(err => {
           console.error(err);
           this.$toast?.fail('Lỗi kết nối');
       });
    },
    handleDeleteDraft(orderId) {
       if(!confirm('Bạn có chắc muốn xóa đơn tạm này?')) return;
       
       this.$root.api.post('logach/postDeleteLoGachTempOrder', { id: orderId }).then(res => {
           if (res.data.status === 'OK') {
               this.$toast?.success('Đã xóa đơn tạm');
               this.fetchInitialData();
           } else {
               this.$toast?.fail(res.data.message || 'Lỗi xóa đơn tạm');
           }
       }).catch(console.error);
    },
    handleRestoreDraft(order) {
       // Just navigation, Home.vue handles restoring from localStorage 'restoreOrder'
       // Ideally we should pass this via state/props but for minimal refactor we keep using the LS mechanism for "intent to restore"
    },

    // --- PRODUCTS ---
    handleUpdateProduct(updatedProduct) {
      const formData = new FormData();
      formData.append('id', updatedProduct.id);
      formData.append('name', updatedProduct.name);
      formData.append('code', updatedProduct.code);
      formData.append('sale_price', updatedProduct.price);
      formData.append('cost_price', updatedProduct.costPrice);
      formData.append('stock_quantity', updatedProduct.stock);
      formData.append('unit', updatedProduct.unit);
      formData.append('category_id', updatedProduct.category);
      formData.append('status', updatedProduct.status);

      if (updatedProduct.image_base64) {
          formData.append('image_base64', updatedProduct.image_base64);
      } else if (updatedProduct.file) {
          formData.append('image', updatedProduct.file);
      } else if (typeof updatedProduct.image === 'string' && !updatedProduct.image.startsWith('blob:')) {
          formData.append('image', updatedProduct.image);
      }
      
      this.$root.api.post('logach/postSaveLoGachProduct', formData).then(res => {
        if (res.data.status === 'OK') {
            // Update the product with the new image URL returned from server if available
            if (res.data.image) {
                updatedProduct.image = res.data.image;
            }
            
            const index = this.products.findIndex(p => p.id === updatedProduct.id);
            if (index !== -1) {
                this.products.splice(index, 1, updatedProduct);
            }
            this.$toast?.('Đã cập nhật sản phẩm');
            this.fetchInitialData();
        } else {
            this.$root.alert(res.data.message || res.data.error || 'Lỗi không xác định', 'Lỗi', 'error');
        }
      }).catch(err => {
          this.$root.showError(err);
      });
    },
    handleAddProduct(newProduct) {
      const formData = new FormData();
      formData.append('name', newProduct.name);
      formData.append('code', newProduct.code);
      formData.append('sale_price', newProduct.price);
      formData.append('cost_price', newProduct.costPrice);
      formData.append('stock_quantity', newProduct.stock);
      formData.append('unit', newProduct.unit);
      formData.append('category_id', newProduct.category);
      formData.append('status', newProduct.status);

      if (newProduct.image_base64) {
          formData.append('image_base64', newProduct.image_base64);
      } else if (newProduct.file) {
          formData.append('image', newProduct.file);
      } else if (typeof newProduct.image === 'string' && !newProduct.image.startsWith('blob:')) {
          formData.append('image', newProduct.image);
      }

      this.$root.api.post('logach/postSaveLoGachProduct', formData).then(res => {
        if (res.data.status === 'OK') {
            newProduct.id = res.data.id;
            // Update image URL if returned
            if (res.data.image) {
                newProduct.image = res.data.image;
            }
            this.products.push(newProduct);
            this.$toast?.('Đã thêm sản phẩm');
            this.fetchInitialData();
        } else {
            this.$root.alert(res.data.message || res.data.error || 'Lỗi không xác định', 'Lỗi', 'error');
        }
      }).catch(err => {
          this.$root.showError(err);
      });
    },
    handleDeleteProduct(productId) {
       this.$root.api.post('logach/postDeleteLoGachProduct', { id: productId }).then(res => {
           if (res.data.status === 'OK') {
               this.$toast?.('Đã xóa sản phẩm');
               this.fetchInitialData();
           } else {
               this.$root.alert(res.data.message, 'Lỗi', 'error');
           }
      }).catch(err => {
          this.$root.showError(err);
      });
    },

    // --- SUPPLIERS ---
    handleAddSupplier(supplier) {
        this.$root.api.post('logach/postSaveLoGachSupplier', supplier).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đã thêm nhà cung cấp');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message || res.data.error, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    handleUpdateSupplier(supplier) {
        this.$root.api.post('logach/postSaveLoGachSupplier', supplier).then(res => {
             if (res.data.status === 'OK') {
                this.$toast?.('Đã cập nhật nhà cung cấp');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message || res.data.error, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    handleDeleteSupplier(id) {
         this.$root.api.post('logach/postDeleteLoGachSupplier', { id: id }).then(res => {
             if (res.data.status === 'OK') {
                this.$toast?.('Đã xóa nhà cung cấp');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message || res.data.error, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },

    // --- STOCK / IMPORT ---
    // TODO: API INTEGRATION [POST] /api/stock-imports (or /api/inventory/import)
    handleImportStock({ product, qty, note, supplierId }) {
        const data = {
            product_id: product.id,
            quantity: qty,
            supplier_id: supplierId || 0,
            note: note,
            user_id: this.viewCurrentUser?.id || this.viewCurrentUser?.userid || 1
        };

        this.$root.api.post('logach/postImportLoGachStock', data).then(res => {
            if (res.data.status === 'OK') {
                this.fetchInitialData();
                this.$toast?.('Đã nhập kho thành công');
            } else {
                this.$root.alert(res.data.error, 'Lỗi', 'error');
            }
        }).catch(err => {
            this.$root.showError(err);
        });
    },
    // TODO: API INTEGRATION [POST] /api/stock-adjustments
    handleAdjustStock(adjustment) {
        const data = {
            product_id: adjustment.product.id,
            quantity: adjustment.quantity, 
            user_id: this.currentUserId,
            note: adjustment.note
        };
        this.$root.api.post('logach/postAdjustLoGachStock', data).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đã điều chỉnh tồn kho');
                this.fetchInitialData(); 
            } else {
                this.$root.alert(res.data.message || res.data.error, 'Lỗi', 'error');
            }
        }).catch(err => {
            this.$root.showError(err);
        });
    },

    // --- ORDERS ---
    // API INTEGRATION [POST] /api/orders
    handleCreateOrder(order) {
        // --- SETTINGS CHECKS ---
        const allowDebt = this.settings?.sales?.allowDebt ?? true;
        
        // 0. Pre-check Debt Logic
        const totalAmount = Number(order.totalBill || order.totalPay || 0);
        const paid = Number(order.paid || 0);
        const remaining = totalAmount - paid;

        if (!allowDebt && remaining > 0) {
            this.$toast?.fail('Cấu hình không được phép bán nợ. Vui lòng thanh toán đủ.');
            return;
        }

        // Prepare Data for API
        const payload = {
            id: order.id, // Optional, can be auto-generated by backend
            customer: order.customer, // Backend handles finding/creating
            cart: order.cart.map(item => ({
                product: { id: item.product.id, name: item.product.name },
                quantity: item.quantity,
                price: item.price,
                cost: item.cost
            })),
            discount: order.discount,
            totalAmount: order.totalAmount, // Before discount
            totalBill: order.totalBill, // After discount
            paid: order.paid,
            cashAmount: order.cashAmount || 0,
            transferAmount: order.transferAmount || 0,
            debt: remaining > 0 ? remaining : 0,
            paymentMethod: order.paymentMethod,
            note: order.note || order.customer.note,
            userId: this.currentUserId,
            createdAt: order.createdAt,
            convertToDeposit: order.convertToDeposit // <--- pass to backend
        };

        this.$root.api.post('logach/postSaveLoGachOrder', payload).then(res => {
             if (res.data.status === 'OK') {
                  this.$toast?.success('Đã tạo đơn hàng thành công');
                  this.fetchInitialData();
                  
                  // Ask to print bill using Vant Dialog
                  this.$dialog.confirm({
                      title: 'Hoàn tất đơn hàng',
                      message: 'Đơn hàng đã được tạo thành công.\nBạn có muốn in hóa đơn ngay không?',
                      confirmButtonText: 'In hóa đơn',
                      cancelButtonText: 'Đóng',
                      confirmButtonColor: '#1989fa' // Blue color for primary action
                  }).then(() => {
                        const orderForPrint = { ...payload, ...order }; 
                        this.handlePrintBill({ 
                            order: orderForPrint, 
                            printType: 'invoice', 
                            isNewOrder: true, 
                            isDraft: false 
                        });
                  }).catch(() => {
                      // Cancelled, do nothing
                  });
             } else {
                  this.$root.alert(res.data.error || 'Lỗi tạo đơn hàng', 'Lỗi', 'error');
             }
        }).catch(err => {
             this.$root.showError(err);
        });
    },
    // TODO: API INTEGRATION [POST] /api/return-orders
    // TODO: API INTEGRATION [POST] /api/return-orders
    async handleReturnOrder(returnOrder) {
        // Map items for API payload. Backend expects 'items' array.
        // Frontend 'returnOrder.items' comes from OrderHistory confirm.
        const items = (returnOrder.items || []).map(i => ({
             productId: i.productId || i.id || i.product?.id,
             // Optional: add name for JSON view
             product_name_snap: i.productName || i.name || i.product?.name, 
             quantity: i.returnQty || i.quantity,
             price: i.price, // For refund calc if needed
        }));

        // Calculate refund amount if not provided
        const refundAmount = parseFloat(returnOrder.totalRefund || items.reduce((sum, i) => sum + (i.price * i.quantity), 0));

        // Logic Debt: Get current debt to calculate surplus
        const customer = this.customers.find(c => c.id === returnOrder.customer.id);
        const currentDebt = customer ? (customer.debtAmount || 0) : 0;
        
        // Use only positive debt for deduction (ignore if they already have credit)
        const currentDebtPositive = Math.max(0, currentDebt);
        let cashRefundAmount = 0;
        if (refundAmount > currentDebtPositive) {
            cashRefundAmount = refundAmount - currentDebtPositive;
        }

        const payload = {
            id: returnOrder.id, // e.g. TH.date...
            customerId: returnOrder.customer.id,
            // Check if user object exists or use current user
            userId: this.currentUserId, 
            orderId: returnOrder.originOrderId || returnOrder.orderId || null, 
            totalRefund: refundAmount,
            // Important: map 'note' to 'reason' if backend expects reason
            reason: returnOrder.reason || returnOrder.note || '',
            createdAt: returnOrder.createdAt,
            items: items,
            refundMode: returnOrder.refundMode
        };

        try {
            const res = await this.$root.api.post('logach/postSaveLoGachReturnOrder', payload);
            if (res.data.status === 'OK') {
                 this.$toast?.('Đã lưu phiếu trả hàng');

                 // Backend automatically handles debt deduction and refund transaction creation
                 if (cashRefundAmount > 0) {
                     this.$toast?.success(`Hệ thống đã tự động tạo phiếu chi hoàn tiền: ${cashRefundAmount.toLocaleString()} đ`);
                 }
                 
                 this.fetchInitialData();
             } else {
                 this.$root.alert(res.data.message || 'Lỗi lưu trả hàng', 'Lỗi', 'error');
             }
        } catch (e) {
             console.error(e);
             this.$root.showError(e);
        }
    },

    // --- USER ---
    // TODO: API INTEGRATION [PUT] /api/users/profile
    handleUpdateUser(updatedUser) {
        this.currentUser = updatedUser;
        localStorage.setItem('userProfile', JSON.stringify(updatedUser)); 
    },

    // --- CATEGORIES ---
    handleAddCategory(category) {
        const data = {
            name: category.name,
            description: category.description || ''
        };
        this.$root.api.post('logach/postSaveLoGachCategory', data).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đã thêm danh mục');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => {
            this.$root.showError(err);
        });
    },
    handleUpdateCategory(category) {
        const data = {
            id: category.id,
            name: category.name,
            description: category.description || ''
        };
        this.$root.api.post('logach/postSaveLoGachCategory', data).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đã cập nhật danh mục');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => {
            this.$root.showError(err);
        });
    },
    handleDeleteCategory(categoryId) {
        this.$root.api.post('logach/postDeleteLoGachCategory', { id: categoryId }).then(res => {
            if (res.data.status === 'OK') {
                this.$toast?.('Đã xóa danh mục');
                this.fetchInitialData();
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => {
            this.$root.showError(err);
        });
    },

    // --- DEBTS ---
    // TODO: API INTEGRATION [POST] /api/debts
    // --- DEBTS ---
    handleAddDebt(debt) {
        let amount = debt.amount;
        let cashAmount = debt.cash_amount || 0;
        let transferAmount = debt.transfer_amount || 0;
        let type = debt.type;
        let note = debt.note || '';
        const isDeposit = type === 'deposit';
        const isRefund = note.includes('[Hoàn cọc]');

        // Handle deposit type: negate amount and mark as receivable
        if (isDeposit) {
            amount = -Math.abs(amount); // Ensure negative
            cashAmount = -Math.abs(cashAmount);
            transferAmount = -Math.abs(transferAmount);
            type = 'receivable';
            if (!note.includes('[Tiền cọc]')) {
                note = '[Tiền cọc] ' + note;
            }
        }

        const formData = {
            partnerId: debt.partnerId,
            partnerType: debt.partnerType,
            type: type,
            amount: amount,
            cashAmount: cashAmount,
            transferAmount: transferAmount,
            note: note.trim()
        };
        // Backend handles sync with customer/supplier balance
        this.$root.api.post('logach/postSaveLoGachDebt', formData).then(res => {
                if (res.data.status === 'OK') {
                  const _uo = this.viewCurrentUser;
                  const creatorName = _uo?.full_name || _uo?.fullname || _uo?.first_name || _uo?.name || _uo?.username || '';
                  const partnerFullName = debt.partnerName || 'khách hàng';
                  // Auto-create Thu/Chi transaction for deposits
                  if (isDeposit) {
                      // Nhận cọc = THU (income)
                      this.handleAddTransaction({
                          type: 'income',
                          amount: Math.abs(debt.amount),
                          cash_amount: Math.abs(debt.cash_amount || 0),
                          transfer_amount: Math.abs(debt.transfer_amount || 0),
                          note: `[Tiền cọc] Nhận cọc từ ${partnerFullName} - Khách hàng: ${partnerFullName} - Người thực hiện: ${creatorName}`
                      });
                      this.$toast?.('Đã ghi nhận tiền cọc + phiếu Thu');
                  } else if (isRefund) {
                      // Hoàn cọc = CHI (expense)
                      this.handleAddTransaction({
                          type: 'expense',
                          amount: Math.abs(debt.amount),
                          cash_amount: Math.abs(debt.cash_amount || 0),
                          transfer_amount: Math.abs(debt.transfer_amount || 0),
                          note: `[Hoàn cọc] Hoàn tiền cọc cho ${partnerFullName} - Khách hàng: ${partnerFullName} - Người thực hiện: ${creatorName}`
                      });
                      this.$toast?.('Đã hoàn cọc + phiếu Chi');
                  } else {
                      this.$toast?.('Đã ghi nhận nợ');
                  }
                  this.fetchInitialData();
              } else {
                  this.$root.alert(res.data.message, 'Lỗi', 'error');
              }
        });
    },
    handleUpdateDebt(debt) {
        const formData = {
            id: debt.id,
            partnerId: debt.partnerId,
            partnerType: debt.partnerType,
            type: debt.type,
            amount: debt.amount,
            note: debt.note
        };
        this.$root.api.post('logach/postSaveLoGachDebt', formData).then(res => {
              if (res.data.status === 'OK') {
                  this.fetchInitialData();
                  this.$toast?.('Đã cập nhật nợ');
              } else {
                  this.$root.alert(res.data.message, 'Lỗi', 'error');
              }
        });
    },
    handlePayDebt({ partnerId, partnerType, partnerName, amount, cash_amount, transfer_amount, type, prePaymentDebt }) {
        if (amount <= 0) return;
        
        const formData = {
            partnerId: partnerId,
            partnerType: partnerType || 'customer',
            type: type || 'receivable',
            amount: -amount, // Negative to reduce the balance
            cashAmount: cash_amount ? -cash_amount : 0,
            transferAmount: transfer_amount ? -transfer_amount : 0,
            note: `Thanh toán nợ: ${partnerName || partnerId}`
        };

        this.$root.api.post('logach/postSaveLoGachDebt', formData).then(res => {
            if (res.data.status === 'OK') {
                this.fetchInitialData();
                
                // Also create financial transaction (Income/Expense)
                const _uo = this.viewCurrentUser;
                const creatorName = _uo?.full_name || _uo?.fullname || _uo?.first_name || _uo?.name || _uo?.username || '';
                const partnerFullName = partnerName || partnerId;
                const transData = {
                    type: type === 'receivable' ? 'income' : 'expense',
                    amount: amount,
                    cashAmount: cash_amount || 0,
                    transferAmount: transfer_amount || 0,
                    note: `Thu nợ: ${partnerFullName} - Khách hàng: ${partnerFullName} - Người thực hiện: ${creatorName}`,
                    createdAt: new Date().toISOString()
                };
                this.$root.api.post('logach/postSaveLoGachTransaction', transData).then(tRes => {
                    if (tRes.data.status === 'OK') {
                        this.fetchLoGachTransactions();
                    }
                });

                this.$toast?.success('Đã ghi nhận thanh toán');

                // ---- DEBT RECEIPT PRINT LOGIC ----
                const showReceipt = () => {
                    const debtPartnerObj = partnerType === 'supplier'
                        ? this.suppliers.find(x => x.id === partnerId)
                        : this.customers.find(x => x.id === partnerId);
                    
                    // Priority to prePaymentDebt to avoid race conditions against fetchInitialData updates
                    const oldDebt = prePaymentDebt !== undefined ? prePaymentDebt : (debtPartnerObj ? (debtPartnerObj.debtAmount || 0) : 0);
                    
                    // For both customer and supplier, a payment (cash/transfer) reduces the outstanding positive debt.
                    // If overpaid, new debt would be negative (meaning deposit).
                    const newDebt = oldDebt - amount;
                    
                    const receiptData = {
                        partnerName: partnerName || partnerId,
                        partnerPhone: debtPartnerObj ? debtPartnerObj.phone : '',
                        createdAt: new Date().toISOString(),
                        createdBy: creatorName,
                        oldDebt: oldDebt,
                        paidAmount: amount,
                        cashAmount: cash_amount || 0,
                        transferAmount: transfer_amount || 0,
                        newDebt: newDebt // allow negative to show deposit in receipt template
                    };
                    this.handlePrintDebtReceipt(receiptData);
                };

                const autoPrint = this.settings?.debtReceipt?.autoPrint;
                
                if (autoPrint) {
                    showReceipt();
                } else {
                    this.$dialog.confirm({
                         title: 'Thanh toán thành công',
                         message: 'Bạn có muốn in phiếu xác nhận thanh toán không?',
                         confirmButtonText: 'In phiếu',
                         cancelButtonText: 'Đóng'
                    }).then(() => {
                         showReceipt();
                    }).catch(() => {});
                }
                // ----------------------------------
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => {
            console.error('Lỗi thanh toán nợ:', err);
        });
    },

    // --- TRANSACTIONS ---
    // --- TRANSACTIONS ---

    // TODO: API INTEGRATION [PUT] /api/transactions/:id
    handleUpdateTransaction(transaction) {
        const index = this.transactions.findIndex(t => t.id === transaction.id);
        if (index !== -1) this.transactions.splice(index, 1, transaction);
        this.$toast?.('Đã cập nhật giao dịch');
        this.fetchInitialData();
    },


    // --- SUPPLIERS ---
    fetchLoGachSuppliers() {
        this.$root.api.get('logach/getLoGachSuppliers').then(res => {
            if (res.data.status === 'OK') {
                this.suppliers = res.data.list.map(s => ({
                    ...s,
                    debtAmount: parseFloat(s.debt_amount || 0)
                }));
                this.calculateDebts();
            }
        });
    },

    // --- CUSTOMERS ---
    // TODO: API INTEGRATION [POST] /api/customers
    handleAddCustomer(customer) {
        if (!customer.id) customer.id = 'CUS-' + Date.now();
        customer.debtAmount = 0; // Init debt
        this.customers.unshift(customer);
        this.$toast?.('Đã thêm khách hàng');
    },
    // TODO: API INTEGRATION [PUT] /api/customers/:id
    handleUpdateCustomer(customer) {
        const index = this.customers.findIndex(c => c.id === customer.id);
        if (index !== -1) this.customers.splice(index, 1, customer);
        this.$toast?.('Đã cập nhật khách hàng');
    },
    // TODO: API INTEGRATION [DELETE] /api/customers/:id
    handleDeleteCustomer(customerId) {
        this.customers = this.customers.filter(c => c.id !== customerId);
        this.$toast?.('Đã xóa khách hàng');
    },

    // --- USERS ---
    // TODO: API INTEGRATION [POST] /api/users
    handleAddUser(user) {
        this.$root.api.post('logach/user/save', user).then(res => {
            if (res.data.status === 'OK') {
                this.fetchInitialData();
                this.$toast?.('Đã thêm người dùng');
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    // TODO: API INTEGRATION [PUT] /api/users/:id
    handleAdminUpdateUser(updatedUser) {
        this.$root.api.post('logach/user/save', updatedUser).then(res => {
            if (res.data.status === 'OK') {
                this.fetchInitialData();
                this.$toast?.('Đã cập nhật người dùng');
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    // TODO: API INTEGRATION [PATCH] /api/users/:id/status
    handleToggleUserStatus({ id, status }) {
        this.$root.api.post('logach/user/toggle-status', { id, status }).then(res => {
             if (res.data.status === 'OK') {
                 this.fetchInitialData();
                 this.$toast?.(`Đã ${status === 'active' ? 'mở khóa' : 'khóa'} tài khoản`);
             } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    // TODO: API INTEGRATION [DELETE] /api/users/:id
    handleDeleteUser(userId) {
        this.$root.api.post('logach/user/delete', { id: userId }).then(res => {
             if (res.data.status === 'OK') {
                 this.fetchInitialData();
                 this.$toast?.('Đã xóa tài khoản');
             } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    // TODO: API INTEGRATION [POST] /api/auth/login
    // Response: { user, token }
    handleLoginSuccess(auth) {
        console.log('handleLoginSuccess:', auth);
        this.currentUserId = auth.id;
        this.currentUser = auth;
        localStorage.setItem('userProfile', JSON.stringify(auth));
        
        this.notifications = [];
        this.$root.unreadNotiCount = 0;

        this.$router.push({ name: 'home' }).then(() => {
            this.$nextTick(() => {
                this.fetchInitialData();
                this.startNotificationPolling();
            });
        }).catch(() => {
            this.fetchInitialData();
            this.startNotificationPolling();
        });
    },
    handleLogin({ phone, password, remember }) {
        const data = { username: phone, password: password };
        this.$root.api.post('logach/user/login', data).then(res => {
            if (res.data.status === 'OK') {
                this.$root.setAuth(res.data.auth);
                // Also handle 'remember' by setting cookie manually if needed, 
                // but main.js setAuth already sets it for 365 days. 
                // We'll trust main.js's 365 days for now to keep it simple.
                
                this.currentUserId = res.data.auth.id;
                this.currentUser = res.data.auth;
                localStorage.setItem('userProfile', JSON.stringify(res.data.auth));
                this.$toast?.('Đăng nhập thành công');
                this.notifications = [];
                this.$root.unreadNotiCount = 0;
                
                this.$router.push({ name: 'home' }).then(() => {
                   this.$nextTick(() => {
                        this.fetchInitialData();
                    });
                }).catch(() => {
                    this.fetchInitialData(); // Fallback
                });
            } else {
                this.$root.alert(res.data.message, 'Lỗi', 'error');
            }
        }).catch(err => this.$root.showError(err));
    },
    handleLogout() {
        const clearLocalSession = () => {
             // Clear everything locally
            this.currentUserId = null;
            this.currentUser = {};
            this.notifications = [];
            this.$root.unreadNotiCount = 0;
            localStorage.removeItem('userProfile');
            this.$root.api.defaults.headers.common['User-Token'] = '';
            
            this.$toast?.('Đã đăng xuất');
            this.stopNotificationPolling();
            // Full reload to ensure total state reset
            window.location.href = '/login';
        };

        this.$root.logout()
            .then(clearLocalSession)
            .catch(clearLocalSession);
    },
    fetchUserAuth() {
        return this.$root.api.get('logach/user/info').then(res => {
            if (res.data.status === 'OK') {
                this.$root.auth = res.data.auth;
                // Update local current user/id just in case
                if (res.data.auth) {
                    this.currentUserId = res.data.auth.id;
                    this.currentUser = res.data.auth;
                }
            }
        }).catch(err => {
            if (err && err.handled) return;
            console.error('Lỗi auth:', err);
        });
    },
    startNotificationPolling() {
        this.stopNotificationPolling();
        console.log('Starting optimized notification polling (60s)');
        this.notiInterval = setInterval(() => {
            if (this.currentUserId) {
                this.checkNewNotifications();
            } else {
                this.stopNotificationPolling();
            }
        }, 60000);
    },
    checkNewNotifications() {
        const userId = this.currentUserId;
        const role = this.viewCurrentUser?.role || 'staff';
        
        this.$root.api.get('logach/getLoGachNotificationCheck', { params: { role, userId } }).then(res => {
            if (res.data.status === 'OK') {
                const { latestId, unreadCount } = res.data;
                
                // If anything changed, do a full fetch
                if (latestId !== this.lastConfirmedLatestId || unreadCount !== this.lastConfirmedUnreadCount) {
                    console.log('New notification activity detected, fetching...', { latestId, unreadCount });
                    this.fetchLoGachNotifications();
                }
            }
        }).catch(err => {
            if (err && err.handled) return;
            console.error('Check notifications error:', err);
        });
    },
    stopNotificationPolling() {
        if (this.notiInterval) {
            console.log('Stopping notification polling');
            clearInterval(this.notiInterval);
            this.notiInterval = null;
        }
    },

    // --- SETTINGS METHODS ---
    // --- SETTINGS METHODS ---
    handleUpdateSettings(section, payload) {
        if (this.settings[section]) {
            this.settings[section] = { ...this.settings[section], ...payload };
            
            // Call API to save settings
            // We save specifically the section updated, or we can save all.
            // For simplicity and to match backend 'key-value' upsert, we send the whole section.
            // Payload for backend: { settings: { [section]: this.settings[section] } }
            this.$root.api.post('logach/postSaveLoGachSettings', {
                settings: {
                    [section]: this.settings[section]
                }
            }).then(res => {
                if(res.data.status !== 'OK') {
                    this.$toast?.('Lỗi lưu cấu hình: ' + res.data.message);
                } else {
                     this.$toast?.('Đã cập nhật cấu hình');
                     this.fetchInitialData();
                }
            });
            
            // Backup local
            this.handleSaveSettingsLocal(); 
        }
    },
    // New method for Role updates
    handleUpdateUserRole(section, payload) {
         // payload here is the FULL 'user' object from UserRoleSettings
         // But wait, UserRoleSettings emits 'update' with 'user' and 'payload' (which is the whole localData object)
         // localData has structure: { roles: { admin: { ... }, staff: { ... } } }
         
         if (section === 'user' && payload.roles) {
             this.settings.user = payload;
             
             // Prepare payload for backend: { roles: { 'admin': { permissions: [], menus: [] } } }
             // The backend expects key=roleName, value={ permissions: [], menus: [] }
             
             this.$root.api.post('logach/postSaveLoGachRoles', {
                 roles: payload.roles
             }).then(res => {
                 if (res.data.status === 'OK') {
                      this.$toast?.('Đã cập nhật phân quyền');
                      this.fetchInitialData();
                 } else {
                      this.$toast?.('Lỗi phân quyền: ' + res.data.message);
                 }
             });
             
             this.handleSaveSettingsLocal();
         }
    },

    handleUpdateReportFilter(payload) {
        this.reportFilter = { ...this.reportFilter, ...payload };
    },
    
    handleResetSettings(section) {
        if (this.defaultSettings && this.defaultSettings[section]) {
            this.settings[section] = JSON.parse(JSON.stringify(this.defaultSettings[section]));
            // Trigger save to API
            this.handleUpdateSettings(section, this.settings[section]);
            this.$toast?.('Đã đặt lại cấu hình mặc định');
        }
    },
    handleLoadSettings() {
        // Load from Server
        Promise.all([
            this.$root.api.get('logach/getLoGachSettings'),
            this.$root.api.get('logach/getLoGachRoles')
        ]).then(([resSettings, resRoles]) => {
             // Helper to get data regardless of wrapper
             const getResData = (res) => {
                 if (res.data.status !== 'OK') return null;
                 // Sometimes it might be directly in data, sometimes in data.result, or data.data
                 // Based on observation: getLoGachTempOrders uses res.data.list
                 // My new API returns ['settings' => ...] so it should be res.data.settings
                 return res.data.result || res.data;
             };

             const settingsData = getResData(resSettings);
             const rolesData = getResData(resRoles);

             // 1. Process General Settings
             if (settingsData && settingsData.settings) {
                 const loadedSettings = settingsData.settings;
                 this.settings = { ...this.settings, ...loadedSettings };
                 
                 // Restore Customer Defaults if empty (Fixing user report)
                 if (!this.settings.customer.customerTypes || this.settings.customer.customerTypes.length === 0) {
                      this.settings.customer.customerTypes = ['normal', 'vip', 'agent'];
                      this.settings.customer.defaultCustomerType = 'normal';
                      this.settings.customer.debtLimitByType = {
                          normal: 5000000,
                          vip: 20000000,
                          agent: 50000000
                      };
                      // Auto-save restored defaults
                      this.handleUpdateSettings('customer', this.settings.customer);
                 }
             }
             
             // 2. Process Roles
             if (rolesData && rolesData.roles) {
                 // Convert Array of Roles from DB back to Object { admin: {}, staff: {} }
                 const rolesArr = rolesData.roles; // [{role_name: 'admin', permissions: [], ...}]
                 
                 // If database is empty, Seed defaults!
                 if (rolesArr.length === 0) {
                      this.settings.user.roles = {
                          admin: {
                              permissions: ['createOrder', 'editPrice', 'viewProfit', 'manageDebt', 'manageUsers', 'manageProducts', 'viewReports', 'manageSettings'],
                              menus: ['home', 'temporaryorder', 'orderhistory', 'admin', 'revenuereport', 'returnhistory', 'productlist', 'importhistory', 'category', 'debt', 'transaction', 'supplier', 'customer', 'user', 'settings', 'printedbills', 'notifications']
                          },
                          staff: {
                              permissions: ['createOrder'],
                              menus: ['home', 'temporaryorder', 'orderhistory', 'productlist', 'customer', 'notifications','admin']
                          },
                          accountant: {
                              permissions: ['viewProfit', 'manageDebt', 'viewReports'],
                              menus: ['home', 'orderhistory', 'revenuereport', 'debt', 'transaction', 'customer', 'notifications']
                          }
                      };
                      // Auto-save these defaults to DB immediately so next time they load!
                      this.handleUpdateUserRole('user', this.settings.user);
                 } else {
                     // Init if empty
                     if (!this.settings.user) this.settings.user = { roles: {} };
                     if (!this.settings.user.roles) this.settings.user.roles = {};
                     
                     // Build new object to ensure reactivity
                     const newRoles = {};
                     rolesArr.forEach(r => {
                         newRoles[r.role_name] = {
                             permissions: r.permissions || [],
                             menus: r.allowed_menus || []
                         };
                     });
                     // Vue 2 Reactivity: Assign the whole object
                     this.settings.user.roles = newRoles;
                 }
             }
             
             // Save to local for fast access next reload (cache)
             // this.handleSaveSettingsLocal(); 
             // Note: SaveLocal might overwrite customized local state if API is partial
             // But for sync purpose, API is truth.
             localStorage.setItem('pos_settings', JSON.stringify(this.settings));
             
        }).catch(err => {
            console.error('Failed to load settings from API, falling back to local', err);
            // Fallback
             const saved = localStorage.getItem('pos_settings');
             if (saved) {
                 try {
                     this.settings = { ...this.settings, ...JSON.parse(saved) };
                 } catch(e) {}
             }
        });
    },
    handleSaveSettingsLocal() {
        localStorage.setItem('pos_settings', JSON.stringify(this.settings));
    },
    calculateDebts() {
        // Reset
        this.customers.forEach(c => c.debtAmount = 0);
        this.suppliers.forEach(s => s.debtAmount = 0);

        this.debts.forEach(debt => {
            if (debt.partnerType === 'customer') {
                const c = this.customers.find(x => x.id === debt.partnerId);
                if (c) c.debtAmount = (c.debtAmount || 0) + debt.amount;
            } else if (debt.partnerType === 'supplier') {
                const s = this.suppliers.find(x => x.id === debt.partnerId);
                if (s) s.debtAmount = (s.debtAmount || 0) + debt.amount;
            }
        });
    }
  }
};
</script>

<style>
/* Print Styles */
#printable-area {
  display: none;
}

@media print {
  /* Hide Vant UI overlays (toast, dialog, popup, notify) */
  .van-toast,
  .van-dialog,
  .van-overlay,
  .van-popup,
  .van-notify,
  .van-toast__text,
  .van-loading {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
  }

  /* Hide every direct child of #app except #printable-area */
  #app > *:not(#printable-area) {
    display: none !important;
  }
  
  #printable-area {
    display: block !important;
    width: 100%;
    margin: 0;
    padding: 0 !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }

  #printable-area .bill-template {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    overflow: visible !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
  }

  #printable-area .bill-template .d-flex {
    overflow: visible !important;
  }

  #printable-area .bill-template table {
    table-layout: fixed !important;
    word-wrap: break-word !important;
  }
  
  /* Reset body/app backgrounds for printing */
  body, #app {
    background: white !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  @page {
    margin: 0mm;
  }

  /* Each copy on its own page */
  .print-copy-page {
    page-break-after: always;
    page-break-inside: avoid;
    padding: 12mm 12mm 0 12mm !important;
    box-sizing: border-box !important;
  }
  .print-copy-page:last-child {
    page-break-after: avoid;
  }
}
</style>

</style>

